<template>
  <div>
    <v-expansion-panels v-if="isMobile" class="ml-2 pr-4 mt-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Financial Analytics
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              class="px-4 mt-4"
              v-for="(info, i) in financeTotal"
              :key="i + Math.random()"
              :cols="isMobile ? 12 : 3"
            >
              <CardAlert :color="colors[i]"
                ><span
                  >{{ info.description }} {{ getCurrency
                  }}{{ formatMoney(info.amount) }}</span
                ></CardAlert
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row v-else class="px-4">
      <v-col
        :cols="isMobile ? 12 : 3"
        class="mt-4"
        v-for="(info, i) in financeTotal"
        :key="i + Math.random()"
      >
        <CardAlert :color="colors[i]"
          ><span
            >{{ info.description }} {{ getCurrency
            }}{{ formatMoney(info.amount) }}</span
          ></CardAlert
        >
      </v-col>
    </v-row>

    <div v-if="isMobile">
      <v-expansion-panels class="ml-2 pr-4 mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header> View Quotations </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col :cols="12">
              <v-card class="ml-1 mt-4">
                <v-toolbar color class="mb-1">
                  <v-toolbar-title :style="{ color: getOutlineColor }"
                    >Quotes</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#01579B"
                    dark
                    x-small
                    rounded
                    @click="openConvertToInvoiceDialog()"
                    ><v-icon x-small>mdi-arrow-right</v-icon>Invoice</v-btn
                  >

                  <v-icon @click="deleteSelectedQuotes()" color="red"
                    >mdi-delete</v-icon
                  >
                </v-toolbar>

                <v-list two-line>
                  <v-list-item
                    v-for="(props, i) in quotes"
                    :key="i + Math.random()"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle :style="{ color: getThemeColor }">
                        {{
                          props.client.name + " [" + props.quote_number + "]"
                        }}</v-list-item-subtitle
                      >
                      <v-list-item-subtitle :style="{ color: getThemeColor }">
                        {{ props.client.institution }}</v-list-item-subtitle
                      >
                      <v-list-item-subtitle
                        v-if="props.calculation"
                        :style="{ color: '#004D40' }"
                      >
                        {{ getCurrency + props.calculation.total }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle :style="{ color: getThemeColor }"
                        >{{ "Date: " + props.quote_date }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        class="shrink"
                        :value="props.item"
                        v-model="selectedQuotesForConversion"
                      ></v-checkbox>
                      <v-icon
                        :color="getOutlineColor"
                        @click="editSelectedQuote(props)"
                        >mdi-pencil</v-icon
                      >
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </v-card>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-col :cols="12">
        <v-card class="ml-1 mt-4">
          <InvoiceTable
            @edit-invoice="editSelectedInvoice"
            :invoices="invoices"
            @refresh-needed="$emit('refresh-data')"
          ></InvoiceTable>
        </v-card>
      </v-col>
    </div>
    <v-layout v-else>
      <v-col :cols="3">
        <v-card class="ml-1 mt-4">
          <v-toolbar color class="mb-1">
            <v-toolbar-title :style="{ color: getOutlineColor }"
              >Quotes</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              color="#01579B"
              dark
              x-small
              rounded
              @click="openConvertToInvoiceDialog()"
              ><v-icon x-small>mdi-arrow-right</v-icon>Invoice</v-btn
            >

            <v-icon @click="deleteSelectedQuotes()" color="red"
              >mdi-delete</v-icon
            >
          </v-toolbar>

          <v-virtual-scroll :items="quotes" height="600" item-height="100">
            <template v-slot:default="props">
              <v-list two-line>
                <v-list-item :key="props.index + Math.random()">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      :style="{ color: getThemeColor }"
                      v-text="
                        props.item.client.name +
                        ' [' +
                        props.item.quote_number +
                        ']'
                      "
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      :style="{ color: getThemeColor }"
                      v-text="props.item.client.institution"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="props.item.calculation"
                      v-text="getCurrency + props.item.calculation.total"
                      :style="{ color: '#004D40' }"
                    >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      :style="{ color: getThemeColor }"
                      v-text="'Date: ' + props.item.quote_date"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-checkbox
                      class="shrink"
                      :value="props.item"
                      v-model="selectedQuotesForConversion"
                    ></v-checkbox>
                    <v-icon
                      :color="getOutlineColor"
                      @click="editSelectedQuote(props.item)"
                      >mdi-pencil</v-icon
                    >
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </v-list>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-col>
      <v-col :cols="9">
        <v-card class="ml-1 mt-4">
          <InvoiceTable
            :invoices="invoices"
            @refresh-needed="$emit('refresh-data')"
            @edit-invoice="editSelectedInvoice"
          ></InvoiceTable>
        </v-card>
      </v-col>
    </v-layout>

    <GlobalDialogSlot
      v-if="convertToInvoiceDialog"
      :title="
        'Convert Selected ' +
        (selectedQuotesForConversion.length == 1 ? ' Quote' : ' Quotes') +
        ' To ' +
        (selectedQuotesForConversion.length == 1 ? ' Invoice' : ' Invoices')
      "
      :dialog="globalDialogSlot"
      @close-dialog="closeDialog"
    >
      <v-card>
        <v-card-title>
          {{ selectedQuotesForConversion.length }}
          {{ selectedQuotesForConversion.length == 1 ? " Quote" : " Quotes" }}
          Selected
        </v-card-title>
        <v-card-actions>
          <v-btn
            class="mx-4 my-2"
            :color="getThemeColor"
            dark
            @click="convertToInvoiceNow()"
            >Convert Now</v-btn
          >
        </v-card-actions>
      </v-card>
    </GlobalDialogSlot>

    <GlobalConfirmDeleteDialog
      :item="confirmDeleteTitle"
      @delete-confirmed="takeActionAfterDeleteChoice"
    ></GlobalConfirmDeleteDialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import InvoiceTable from "./InvoiceTable.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  props: ["data"],
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getGlobalDialogSlot() {
      return this.$store.getters.getGlobalDialogSlot;
    },
  },
  components: {
    GlobalConfirmDeleteDialog,
    GlobalDialogSlot,
    InvoiceTable,
    CardAlert,
  },
  watch: {
    data() {
      this.getAndSetData();
    },
  },
  mounted() {
    this.getAndSetData();
  },
  created() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  data: () => ({
    invoicePanel: 0,
    globalDialogSlot: false,
    convertToInvoiceDialog: false,
    colors: ["warning", "primary", "#1B5E20", "red", "#3E2723"],
    table: null,
    searchQuotes: null,
    confirmDeleteTitle: null,
    invoices: [],

    selectedInvoicesForPayment: [],
    selectedQuotesForConversion: [],
    selectedQuote: null,
    quotes: [],
    selectedQuotes: [],
    quoteHeaders: [
      { value: "selection" },
      {
        text: "Client",
        align: "start",
        value: "client.name",
      },
      {
        text: "Quote Number",
        value: "quote_number",
      },
      {
        text: "Amount",
        value: "calculation.total",
      },
      {
        text: "Date",
        value: "quote_date",
      },
    ],
    financeTotal: [
      { description: "Total Quotes", amount: 0 },
      { description: "Total Invoices", amount: 0 },
      { description: "Total Paid", amount: 0 },
      { description: "Outstanding", amount: 0 },
    ],
  }),
  methods: {
    formatMoney(amount) {
      return axios.formatMoney(amount);
    },
    getAndSetData() {
      this.table = null;
      if (this.data && this.data.invoices) {
        this.invoices = this.data.invoices;
        this.financeTotal[1]["amount"] = 0;
        this.financeTotal[2]["amount"] = 0;
        this.financeTotal[3]["amount"] = 0;

        if (this.data.invoices.length > 0) {
          this.data.invoices.forEach((invoice) => {
            if (invoice && invoice.calculation) {
              this.financeTotal[1]["amount"] += Number(
                invoice.calculation.total
              );
              this.financeTotal[2]["amount"] += Number(invoice.totalPayment);
              this.financeTotal[3]["amount"] +=
                Number(invoice.calculation.total) -
                Number(invoice.totalPayment);
            }
          });
        }
      }

      if (this.data && this.data.quotations) {
        this.quotes = this.data.quotations;
        this.financeTotal[0]["amount"] = 0;
        this.data.quotations.forEach((quote) => {
          if (quote && quote.calculation) {
            this.financeTotal[0]["amount"] += Number(quote.calculation.total);
          }
        });
      }
    },
    editSelectedInvoice(invoice) {
      this.selec;
      this.$emit("edit-invoice", invoice);
    },
    editSelectedQuote(quote) {
      this.selectedQuote = quote;
      this.selectedQuote.quoteNumber = quote.quote_number;
      this.$emit("edit-quote", this.selectedQuote);
    },
    bulkDeleteItems(rowIds) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bulk-delete",
          { table: this.table, rowIds },
          this.getAccessToken
        )
        .then(() => {
          this.$emit("items-deleted");
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    deleteSelectedQuotes() {
      if (this.selectedQuotesForConversion.length < 1) {
        alert("You Must Select Atleast 1 Item");
        event.preventDefault();
      } else {
        this.$store.commit("setGlobalConfirmDelete", true);
        this.confirmDeleteTitle = "Selected Quotations";
        this.table = "quotations";
      }
    },
    openConvertToInvoiceDialog() {
      if (this.selectedQuotesForConversion.length < 1) {
        alert("You Must Select Atleast 1 Item");
        event.preventDefault();
      } else {
        this.convertToInvoiceDialog = true;
        this.globalDialogSlot = true;
      }
    },
    takeActionAfterDeleteChoice(choice) {
      if (choice) {
        this.selectedQuotes = [];
        this.selectedQuotesForConversion.forEach((quote) => {
          this.selectedQuotes.push(quote.id);
        });
        this.bulkDeleteItems(this.selectedQuotes);
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
        this.table = null;
      }
    },
    convertToInvoiceNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/convert-quotes-to-invoices",
          { selectedQuotesForConversion: this.selectedQuotesForConversion },
          this.getAccessToken
        )
        .then(() => {
          this.$store.commit("setLoader", false);
          this.closeDialog();
          this.$emit("refresh-data");
        });
    },
    closeDialog() {
      this.selectedQuotes = [];
      this.selectedQuotesForConversion = [];
      this.globalDialogSlot = false;
      this.convertToInvoiceDialog = false;
    },
  },
};
</script>

<style></style>
